import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Gift, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { SEASON } from "@/lib/constants";

// Shows a call-to-action when there is an active bonus for `game` that the
// user is eligible for and has NOT yet played on at least one subscription.
export const BonusBanner = ({ game, persist = false }) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [label, setLabel] = useState("");

  useEffect(() => {
    let alive = true;
    // Ticket usa i bonus PER-STANZA (endpoint dedicato /tiket-bonus): non
    // sono bonus di giornata (bonus_configs), quindi il banner va calcolato
    // dalle stanze in cui c'è un Big Match ancora giocabile.
    if (game === "tiket") {
      api("/tiket-bonus")
        .then((list) => {
          if (!alive) return;
          const open = (list || []).filter((b) => !b.locked);
          if (open.length === 0) return;
          const toPlay = open.filter((b) => !b.my_pick);
          if (!persist && toPlay.length === 0) return;
          if (open.length === 1) {
            const b = open[0];
            setLabel(`Big Match — risultato esatto · ${b.home} - ${b.away}`);
          } else {
            const n = toPlay.length > 0 ? toPlay.length : open.length;
            setLabel(`Big Match — risultato esatto · ${n} ${n === 1 ? "stanza" : "stanze"} da giocare`);
          }
          setShow(true);
        })
        .catch(() => {});
      return () => { alive = false; };
    }
    api(`/bonus/available?game=${game}&season=${SEASON}`)
      .then((d) => {
        if (!alive) return;
        if (!d?.eligible || !d?.config) return;
        const subs = d.subscriptions || [];
        const anyToPlay = subs.some((s) => !s.my_pick);
        if (!persist && !anyToPlay) return;
        const t = d.bonus_type === "exact_score" ? "Big Match — risultato esatto" : "Primo marcatore";
        setLabel(`${t} · Giornata ${d.config.matchday}`);
        setShow(true);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [game, persist]);

  if (!show) return null;
  return (
    <button
      data-testid={`bonus-banner-${game}`}
      onClick={() => navigate(`/bonus?tab=${game}`)}
      className="w-full text-left rounded-xl border border-[#10B981]/50 bg-gradient-to-r from-[#10B981]/20 to-[#10B981]/5 p-4 flex items-center gap-3 hover:border-[#10B981] transition-colors animate-fadeup"
    >
      <div className="w-11 h-11 rounded-lg bg-[#10B981]/25 flex items-center justify-center shrink-0">
        <Gift size={22} className="text-[#10B981]" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-extrabold text-[#10B981]">Gioca il tuo Bonus!</div>
        <div className="text-sm text-[#94A3B8] truncate">{label}</div>
      </div>
      <ChevronRight size={20} className="text-[#10B981] shrink-0" />
    </button>
  );
};
